jQuery(function ($) {
    $('.fff-colorPicker').each(function () {
        const $picker = $(this);
        const $image = $(this).find('img');
        const $colors = $(this).find('.fff-colorPicker__color');
        const origImgSrc = $image.attr('src');
        let spaceRequirement;
        setTimeout(() => {
            spaceRequirement = $picker.outerWidth();
            checkSizeConstraints();
        }, 200);
        $colors.hover(function () {
            const newImage = $(this).data('tint-image-src');
            if (newImage)
                $image.attr('src', newImage);
        });
        $(this).on('mouseleave', function () {
            $image.attr('src', origImgSrc);
        });
        function checkSizeConstraints() {
            if (!spaceRequirement)
                return;
            const $parent = $picker.parent();
            const parentContentWidth = $parent.width();
            if (spaceRequirement <= parentContentWidth)
                $picker.removeClass('-collapsed');
            else
                $picker.addClass('-collapsed');
        }
        $(window).on('resize', function () {
            setTimeout(() => {
                checkSizeConstraints();
            }, 50);
        });
    });
});
